module.exports = __webpack_public_path__ + "img/dineIn.8fd4dbe4.svg";